import { PhoneOutlined } from "@ant-design/icons";

export default function PhoneNumber({ children }: { children: string }) {
  return (
    <>
      <PhoneOutlined />
      <a href={`tel://${spaceless(children)}`} style={{ marginLeft: 4 }}>
        {children}
      </a>
    </>
  );
}

function spaceless(input: string): string {
  return input.replace(/\s/g, "");
}
